import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiveOhOh } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';

function ServerDead() {
    const { t } = useTranslation();
    const history = useHistory();

    return <FiveOhOh tFunc={t} onLinkClick={() => history.push('/')} />;
}

export default ServerDead;
